import React from 'react';

function Technology() {
  return (
    <section className="technology-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Advanced Cognitive Architecture</h2>
          <p className="section-subtitle">
            Powered by cutting-edge graph-based intelligence and knowledge graphs
          </p>
        </div>

        <div className="technology-content">
          <div className="tech-visual">
            <div className="neural-network">
              <div className="layer input-layer">
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
              </div>
              <div className="layer hidden-layer">
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
              </div>
              <div className="layer hidden-layer">
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
              </div>
              <div className="layer output-layer">
                <div className="neuron"></div>
                <div className="neuron"></div>
                <div className="neuron"></div>
              </div>
            </div>
          </div>

          <div className="tech-features">
            <div className="tech-feature">
              <div className="tech-feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="16" cy="16" r="6" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="16" cy="16" r="2" fill="currentColor"/>
                </svg>
              </div>
              <div className="tech-feature-content">
                <h4>Intelligent Nodes</h4>
                <p>Distributed processing units that learn and adapt independently</p>
              </div>
            </div>

            <div className="tech-feature">
              <div className="tech-feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <line x1="6" y1="16" x2="26" y2="16" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="6" cy="16" r="3" fill="currentColor"/>
                  <circle cx="26" cy="16" r="3" fill="currentColor"/>
                  <line x1="16" y1="6" x2="16" y2="26" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="16" cy="6" r="3" fill="currentColor"/>
                  <circle cx="16" cy="26" r="3" fill="currentColor"/>
                </svg>
              </div>
              <div className="tech-feature-content">
                <h4>Intelligent Connections</h4>
                <p>Dynamic pathways that strengthen with learning and usage</p>
              </div>
            </div>

            <div className="tech-feature">
              <div className="tech-feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <rect x="4" y="4" width="24" height="24" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <line x1="4" y1="12" x2="28" y2="12" stroke="currentColor" strokeWidth="2"/>
                  <line x1="4" y1="20" x2="28" y2="20" stroke="currentColor" strokeWidth="2"/>
                  <line x1="12" y1="4" x2="12" y2="28" stroke="currentColor" strokeWidth="2"/>
                  <line x1="20" y1="4" x2="20" y2="28" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <div className="tech-feature-content">
                <h4>Knowledge Graphs</h4>
                <p>Semantic networks that capture complex relationships and context</p>
              </div>
            </div>

            <div className="tech-feature">
              <div className="tech-feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M4 20 L12 12 L20 16 L28 8" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="3" fill="currentColor"/>
                  <circle cx="20" cy="16" r="3" fill="currentColor"/>
                  <circle cx="28" cy="8" r="3" fill="currentColor"/>
                </svg>
              </div>
              <div className="tech-feature-content">
                <h4>Continuous Learning</h4>
                <p>Self-improving algorithms that evolve with your business</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Technology;

